import { writable } from 'svelte/store';
export const selectedFilterTitle = writable('Фильтры');
export const tab = writable('');
export const searchValue = writable('');
export const filtersData = writable([]);
export const list = writable([]);
export const pagination = writable(null);
export const deletePublicationId = writable(0);
export const currentPage = writable(1);
export const selectedFiltersCount = writable(0);
export const isShowFilters = writable(false);
export const isShowClearAction = writable(false);
export const isShowDeleteModal = writable(false);
export const filterList = writable([
    { id: 1, title: 'По дате', value: 'date' },
    { id: 2, title: 'По группе', value: 'group' },
    { id: 3, title: 'По потоку', value: 'flows' },
    { id: 4, title: 'По разделу', value: 'sections' },
    { id: 5, title: 'По тегу', value: 'tags' },
]);
export const selectedFilters = writable({
    date: { beforeApplyValue: [], value: [] },
    group: { beforeApplyValue: [], value: [] },
    flows: { beforeApplyValue: [], value: [] },
    sections: { beforeApplyValue: [], value: [] },
    tags: { beforeApplyValue: [], value: [] },
});
